import { formatINR } from "@/utils/goldSilverParser";
import {
  DecreaseArrowIcon,
  IncreaseArrowIcon,
} from "@/component/GoldSilver/Icons";

const colorSelector = (isGold) => {
  return {
    panelBg: isGold ? "bg-[#FBF3DF]" : "bg-[#F4F5F6]",
    gradient: isGold
      ? "bg-[linear-gradient(90deg,#F0A500_0%,#FFDF10_50%,#F4B000_100%)]"
      : "bg-[linear-gradient(90deg,#C8C8C8_0%,#F4F4F4_48%,#BDBDBD_100%)]",
  };
};

function TrendBadge({ trend, diff }) {
  if (!trend || !diff) return null;
  const isDown = trend === "decrease";
  return (
    <span
      className={`inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full border text-xs font-medium ${isDown ? "border-red-300 text-red-500" : "border-green-300 text-green-600"}`}
    >
      {isDown ? "-" : "+"}
      {diff}
      {isDown ? <DecreaseArrowIcon /> : <IncreaseArrowIcon />}
    </span>
  );
}

function PricePanel({ label, price, trend, diff, isGold, href }) {
  const colors = colorSelector(isGold);
  return (
    <a href={href} className={`flex-1 min-w-0 ${colors.panelBg} flex flex-col`}>
      <div className="flex-1 px-3 py-4 md:py-3 flex flex-col gap-1">
        <span className="text-sm md:text-xs text-gray-600 whitespace-nowrap">{label}</span>
        <div className="flex items-center gap-1.5 flex-wrap">
          <span className="text-lg md:text-base font-bold whitespace-nowrap">
            {formatINR(price)}
          </span>
          <TrendBadge trend={trend} diff={diff} />
        </div>
      </div>
      <div className={`h-1.5 shrink-0 mt-auto ${colors.gradient}`}></div>
    </a>
  );
}

export default function GoldSilverBanner({ priceData = null, showHeading=true, cityName = null }) {
  const gold = priceData?.gold;
  const silver = priceData?.silver;

  return (
    <div className="flex flex-col gap-1.5">
      {showHeading && (
        <h3 className="text-md text-center font-bold text-gray-800">
          {cityName ? `${cityName} में सोने/ चांदी के भाव (Gold/ Silver Price Today)` : "सोने/ चांदी के भाव (Gold/ Silver Price Today)"}
        </h3>
      )}
      <div className="w-full flex rounded-xl overflow-hidden border border-gray-200 divide-x divide-gray-200">
        <PricePanel
          href={gold?.pageHref}
          label="24K Gold /g"
          price={gold?.oneGram?.carat24}
          trend={gold?.trend24}
          diff={gold?.difference24}
          isGold={true}
        />
        <PricePanel
          href={silver?.pageHref}
          label="Silver /10g"
          price={silver?.tenGram}
          trend={silver?.trendTenGram}
          diff={silver?.differenceTenGram}
          isGold={false}
        />
      </div>
    </div>
  );
}
